// CSS
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
// Components
import { NavBar } from "./components/NavBar";
import { Banner } from "./components/Banner";
import { Skills } from "./components/Skills";
import { Projects } from "./components/Projects";
import { Footer } from "./components/Footer";
import { About } from "./components/About";

function App() {
  console.log("Hire me :)")
  return (
    <div className="App">
     
      <NavBar />
      <Banner />
      <Skills />
      <Projects />
      <About/>
      <Footer />
      {/* implement back to the top button that slowly renders as your reach the bottom */}
    </div>
  );
}

export default App;
